import React, {useEffect} from "react";
import { useForm } from 'react-hook-form';

// components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  Spinner,
  Row
} from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_PUT } from "../../services/api_service.js";

export default function EsqueceuSenha({ history }) {

    const { register, handleSubmit } = useForm({ mode: "onBlur" });

    const[loading, set_loading] = React.useState(false);

    useEffect(() => {
    }, []);

    const [loginExiste, setLoginExiste] = React.useState(false);
    const [login, setLogin] = React.useState("");
    const handleLogin = (event) => {
      if (event.target.value == "")
      {
        setLoginExiste(false);
        setLogin("");
        return;
      }

      let input_login = event.target.value;
  
      set_loading(true);
      api_GET(`usuario/verificaLogin/${event.target.value}`).then(result => {
        set_loading(false);
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else{
          setLoginExiste(result.data);
          setLogin(input_login);
        }
      });
    }
  
    const onSubmit = (data) => {
    
      set_loading(true);

      let new_password = Math.random().toString(36).slice(-8);
      let json_post = {
        login: login,
        email: data.email,
        password: new_password
      }
  
      api_PUT(`usuario/EsqueceuSenha`, json_post).then(result => {        
        if (result.status !== 200) {
          set_loading(false);
          showMessage("Atenção", result.message, 'error' , null);
        }
        else{
            showMessage("Atenção", "Uma senha temporária foi enviada para seu email", 'success' , function(){history.push("/auth/login");});    
        }
      });
    };
  
    return (
      <>
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardHeader className="bg-transparent pb-5">
              <div className="text-muted text-center mt-2 mb-3">
                <strong>Esqueceu a Senha</strong>
              </div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-5">
              <form onSubmit={handleSubmit(onSubmit)}>
                {!loginExiste &&
                  <FormGroup className="mb-3">
                    <strong>Informe o seu login de usuário:</strong>
                    <br/><br/>
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-single-02" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="Login" type="text" name="login" onBlur={handleLogin} innerRef={register({ required: true })}/>
                    </InputGroup>
                  </FormGroup>
                }
                {loginExiste &&
                  <div>
                    <FormGroup className="mb-3">
                      <strong>Digite seu email para receber uma senha temporária:</strong>
                      <br/><br/>
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Email" type="text" name="email" innerRef={register({ required: true })}/>
                      </InputGroup>
                    </FormGroup>
                    <div className="text-center">
                      <Button className="my-4" color="primary" type="submit">
                        {loading && <Spinner size="sm" color="secondary" />} 
                        &nbsp; Enviar Email &nbsp;
                      </Button>
                    </div>
                  </div>
                }
              </form>
            </CardBody>
          </Card>
          <Row className="mt-3">
            <Col xs="6">
              <a
                className="text-light"
                style={{cursor:"pointer"}}
                onClick={() => {history.push("/auth/login");}}
              >
                <small>Voltar</small>
              </a>
            </Col>
          </Row>
        </Col>
      </>
    );
  }
  